/*
 * @Author: your name
 * @Date: 2020-12-13 15:27:12
 * @LastEditTime: 2022-11-03 14:46:50
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/api/tab.js
 */
import request from '@/utils/request'

// All interface urls of this file need to be declared here because request You need to use the
// 此文件中，所有的接口 url，需要在这里声明。因为 'request.js' 文件中需要使用。
export const submitBugUrl = '/customer/default/submit-bug'

export function submitBug(data) {
  return request({
    url: submitBugUrl,
    data
  })
}
